import { t } from '@/features/i18n/utils';
import { Logo } from '@/ui/components/logo';
import { useAuth } from '@/features/auth';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/activate-account')({
  component: RouteComponent,
});

function RouteComponent() {
  const { logout } = useAuth();

  return (
    <div className="px-5 -translate-y-5 w-full flex flex-col items-center">
      <Logo className="mb-5 mx-auto" />
      <p className="text-center font-semibold text-lg mb-6">
        {t({ en: 'Check your email', nb: 'Sjekk din e-post' })}
      </p>
      <p className="mb-6">
        {t({
          en: 'Welcome to Volve! Thank you for signing up. To get started, please check your inbox for a confirmation email and activate your account.',
          nb: 'Velkommen til Volve! Takk for at du registrerte deg. For å komme i gang, vennligst sjekk innboksen din for en bekreftelses-e-post og aktiver din konto.',
        })}
      </p>
      <h2 className="font-semibold mb-2">
        {t({ en: 'Why is activation required?', nb: 'Hvorfor er aktivering nødvendig?' })}
      </h2>
      <ul className="pb-6 list-disc ml-4">
        <li>
          {t({
            en: 'To verify your email address and secure your account.',
            nb: 'For å bekrefte din e-postadresse og sikre din konto.',
          })}
        </li>
        <li>
          {t({
            en: `To unlock full access to all features of ${'Volve'}.`,
            nb: `For å låse opp full tilgang til alle funksjoner i ${'Volve'}.`,
          })}
        </li>
      </ul>
      <h2 className="font-semibold mb-2">
        {t({ en: "Didn't receive the email?", nb: 'Mottok du ikke e-posten?' })}
      </h2>
      <ul className="pb-6 list-disc ml-4">
        <li>{t({ en: 'Check your spam or junk folder.', nb: 'Sjekk din søppelpostmappe.' })}</li>
        <li>
          {t({
            en: 'Make sure the email address you provided is correct.',
            nb: 'Sørg for at e-postadressen du oppga er riktig.',
          })}
        </li>
      </ul>
      <p>
        {t({
          en: "Once your email is activated, you'll be able to create an Organisation and use all the offered features.",
          nb: 'Når din e-post er aktivert, vil du kunne opprette en organisasjon og bruke alle de tilbudte funksjonene.',
        })}
      </p>
      <footer className="pt-6 text-center">
        <span>
          {t({
            en: 'Want to sign in with a different account?',
            nb: 'Vil du logge inn med en annen konto?',
          })}
        </span>
        <button
          onClick={logout}
          className="block mt-2 mx-auto text-muted hover:text-foreground underline"
        >
          {t({ en: 'Sign In', nb: 'Logg inn' })}
        </button>
      </footer>
    </div>
  );
}
